import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login.vue'
import store from "../store";
import layout from "@/views/layout.vue";

import personal from "@/views/manager/personal.vue";
import visitor from "@/views/manager/visitor.vue";
import department from "@/views/manager/department.vue";
import personmanager from "@/views/manager/personmanager.vue";
import administrator from "@/views/manager/administrator.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta:{
      isLogin:false
    }
  },

  {
    path: '/manager',
    component: layout,
    name: '/manager',
    redirect: '/manager/personmanager',

    children: [
      {
        path: 'department',
        name: 'department',
        component: department,
        meta: { title: '部门管理'}
      },

      {
        path: 'personal',
        name:'personal',
        component: personal,
        meta: {title: '个人设置'}
      },

      {
        path: 'personmanager',
        name:'personmanager',
        component: personmanager,
        meta: {title: '人员管理'}
      },
      {
        path: 'visitor',
        name:'visitor',
        component: visitor,
        meta: {title: '访客管理'}
      },

      {
        path: 'administrator',
        name:'administrator',
        component: administrator,
        meta: {title: '分管理员管理'}
      },
    ]
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});
// 设置路由守卫，在进页面之前，判断有token，才进入页面，否则返回登录页面
if (localStorage.getItem("token")) {
  store.commit("setToken", localStorage.getItem("token"));
  store.commit("setUserInfo", localStorage.getItem("userName"));
}
router.beforeEach((to, from, next) => {
  // 判断要去的路由有没有requiresAuth
  // to.matched.some(r => r.meta.requireAuth) or to.meta.requiresAuth
  let getFlag=localStorage.getItem("Flag");
  // console.log("toke:"+localStorage.getItem('token'))
  if(getFlag==="isLogin"){
      store.state.isLogin=true;
      next();
      if (!to.meta.isLogin){
        localStorage.setItem("Flag",'');
      }
  }else {
      if(to.meta.isLogin){
        next({
          path: "/login",
        })
      }else {
        next();
      }
  }
});


export default router
